module.exports = __webpack_public_path__ + "img/scorned.e7075f27.png";